module.exports = __webpack_public_path__ + "img/residential-proxy.e45edce5.svg";